import "./QuoteDatePicker.css";
import { RadioButton } from "primereact/radiobutton";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Nullable } from "primereact/ts-helpers";
import { Calendar } from "primereact/calendar";
import {
    instantQuotationSelector,
    setSelectedEndDate,
    setSelectedStartDate
} from "../../features/instantQuotationSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { DatePickerType } from "../../types/DatePickerType";

export const QuoteDatePicker = () => {

    const {
        startDate,
        endDate,
        datePickerType
    } = useAppSelector(instantQuotationSelector);

    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();
    const today = new Date();
    const [date, setDate] = useState<Nullable<Date>>(startDate);
    const [dates, setDates] = useState<Nullable<(Date | null)[]>>((startDate || endDate) ? [startDate,endDate] : null);
    const [dateType, setDateType] = useState(datePickerType);

    const dateComponent = () => {
        if (dateType == DatePickerType.Range) {
            return <div className="field grid mb-3">
                <div className="col-12 md:col-9 md:col-offset-3 flex justify-content-end">

                    <Calendar
                        dateFormat="dd/mm/yy"
                        placeholder={t('instantQuotation.datePrompt')}
                        className={"date-picker-calender"}
                        minDate={today} value={dates} onChange={(e) => {
                        setDate(null);
                        setDates(e.value);
                        if (Array.isArray(e.value)) {
                            dispatch(setSelectedStartDate(e.value[0]));
                            dispatch(setSelectedEndDate(e.value[1]));
                        }
                    }
                    } selectionMode="range"
                        readOnlyInput
                        showIcon icon={() => <i className="pi pi-calendar calendar-icon-color" />} />
                </div>
            </div>

        }

        return <div className="field grid mb-3">
            <div className="col-12 md:col-9 md:col-offset-3 flex justify-content-end">
                <Calendar
                    dateFormat="dd/mm/yy"
                    className={"date-picker-calender"}
                    placeholder={t('instantQuotation.datePrompt')}
                    minDate={today} value={date} onChange={(e) => {
                    setDates(null);
                    setDate(e.value);
                    dispatch(setSelectedStartDate(e.value));
                    dispatch(setSelectedEndDate(null));
                }

                } showIcon icon={() => <i className="pi pi-calendar calendar-icon-color" />} data-cy="calendar" />
            </div>
        </div>

    };

    return <>
        <div className="field grid mb-3">
            <label className="col-12 mb-2 md:col-3 md:mb-0" data-cy="instant-quotation-dates-label">{t("instantQuotation.dates")}</label>
            <div className="col-12 md:col-9 flex justify-content-start" data-cy="instant-quotation-dates-container">
                <div className="flex align-items-center">

                    <RadioButton inputId="single-date" name="single-date" value={DatePickerType.Single_Date}
                                 onChange={(e) => {
                                     setDates(null);
                                     setDateType(e.value);
                                     dispatch(setSelectedEndDate(null));
                                 }
                                 } checked={dateType === DatePickerType.Single_Date}
                                 data-cy="single-date-radio" />
                    <label htmlFor="single-date" className="ml-2" data-cy="single-date-label">{t("instantQuotation.singleDate")}</label>
                </div>
                <div className="flex align-items-center ml-3">
                    <RadioButton inputId="date-range" name="date-range" value={DatePickerType.Range}
                                 onChange={(e) => {
                                     setDate(null);
                                     setDateType(e.value);
                                 }} checked={dateType === DatePickerType.Range}
                                 data-cy="date-range-radio" />
                    <label htmlFor="date-range" className="ml-2" data-cy="date-range-label">{t("instantQuotation.dateRange")}</label>
                </div>
            </div>
        </div>
        {dateComponent()}
    </>


};
